var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_vm._t("bg"),_vm._t("ba-copy")],2)}
var staticRenderFns = []

export { render, staticRenderFns }